import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { Airport } from '../types';
import { Context } from '../../../types';

const AirportsContext = createContext<Context<Airport>>({
    get: api.get,
    getById: api.getById,
    post: api.post,
    put: api.put,
    data: { ids: [], byId: {} },
    setData: noop,
    selected: null,
    setSelected: noop,
    remove: api.remove,
    error: null
});
export default AirportsContext;
